// removed by extract-text-webpack-plugin
module.exports = {"container":"container__1uYiT","inner":"inner__6AyDX","nav":"nav__2_Va3","copyright":"copyright__1bDpy","navItem":"navItem__1E_fk","social":"social__1bYuF"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/footer.css
// module id = Hw2k
// module chunks = 0